import * as API from '../api'
import { downloadPng, fileNamePart } from '../utils/downloads'

export const FETCHING_PRODUCT_MAPS = 'FETCHING_PRODUCT_MAPS'
export const FETCH_PRODUCT_MAPS = 'FETCH_PRODUCT_MAPS'
export const FETCH_PRODUCT_MAPS_ERROR = 'FETCH_PRODUCT_MAPS_ERROR'

export const FETCHING_PRODUCT_MAP = 'FETCHING_PRODUCT_MAP'
export const FETCH_PRODUCT_MAP = 'FETCH_PRODUCT_MAP'
export const FETCH_PRODUCT_MAP_ERROR = 'FETCH_PRODUCT_MAP_ERROR'

export const CHANGING_PRODUCT_MAP_STATUS = 'CHANGING_PRODUCT_MAP_STATUS'
export const CHANGE_PRODUCT_MAP_STATUS = 'CHANGE_PRODUCT_MAP_STATUS'
export const CHANGE_PRODUCT_MAP_STATUS_ERROR = 'CHANGE_PRODUCT_MAP_STATUS_ERROR'

export const FETCHING_PRODUCT_MAPS_DOWNLOAD = 'FETCHING_PRODUCT_MAPS_DOWNLOAD'
export const FETCH_PRODUCT_MAPS_DOWNLOAD = 'FETCH_PRODUCT_MAPS_DOWNLOAD'
export const FETCH_PRODUCT_MAPS_DOWNLOAD_ERROR = 'FETCH_PRODUCT_MAPS_DOWNLOAD_ERROR'

export const FETCHING_PRODUCTS_BY_INVENTORY = 'FETCHING_PRODUCTS_BY_INVENTORY'
export const FETCH_PRODUCTS_BY_INVENTORY = 'FETCH_PRODUCTS_BY_INVENTORY'
export const FETCH_PRODUCTS_BY_INVENTORY_ERROR = 'FETCH_PRODUCTS_BY_INVENTORY_ERROR'

export const CHANGE_PRODUCT_MAPS_STATUS_DOWNLOAD_ERROR = 'CHANGE_PRODUCT_MAPS_STATUS_DOWNLOAD_ERROR'

export const CHANGING_PRODUCT_MAP_AMOUNT = 'CHANGING_PRODUCT_MAP_AMOUNT'
export const CHANGE_PRODUCT_MAP_AMOUNT = 'CHANGE_PRODUCT_MAP_AMOUNT'
export const CHANGE_PRODUCT_MAP_AMOUNT_ERROR = 'CHANGE_PRODUCT_MAP_AMOUNT_ERROR'


export const fetchProductMaps = (areaId, page, rowsPerPage, orderBy, order) => {
  return dispatch => {
    dispatch({
      type: FETCHING_PRODUCT_MAPS,
      value: true
    })

    return API.productMap
      .getProductMaps(areaId, page, rowsPerPage, orderBy, order)
      .then(response => {
        const { data = {} } = response
        const {
          can_change_status: canChangeStatus,
          can_update_amount: canUpdateAmount,
          items,
          last_update,
          total_records,
          pagination
        } = data

        dispatch({
          type: FETCH_PRODUCT_MAPS,
          canChangeStatus,
          canUpdateAmount,
          items,
          last_update,
          total_records,
          pagination
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_PRODUCT_MAPS_ERROR
        })
      })
  }
}

export const fetchProductMap = id => {
  return dispatch => {
    dispatch({
      type: FETCHING_PRODUCT_MAP,
      value: true
    })

    return API.productMap
      .getProductMap(id)
      .then(response => {
        const data = response.data

        dispatch({
          type: FETCH_PRODUCT_MAP,
          productMap: data
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_PRODUCT_MAP_ERROR
        })
      })
  }
}

// Sem actions no store: o loading e o erro do QR só interessam ao modal, e passar pelo
// state.productMap redesenharia a tabela inteira do Mapa a cada clique.
export const downloadProductFdsQrCode = (id, productName = '') =>
  API.productMap
    .getProductFdsQrCode(id)
    .then(response => downloadPng(response.data, `fds-${fileNamePart(productName, id)}.png`))

export const fetchCollectionProductsByInventory = areaId => {
  return dispatch => {
    dispatch({
      type: FETCHING_PRODUCTS_BY_INVENTORY,
      value: true
    })

    return API.productMap
      .getProductByInventory(areaId)
      .then(response => {
        const data = response.data
        const { items } = data

        dispatch({
          type: FETCH_PRODUCTS_BY_INVENTORY,
          items
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_PRODUCTS_BY_INVENTORY_ERROR,
          value: true
        })
      })

  }
}

export const changeProductMapStatus = ({ id, active, areaId }) => {
  return dispatch => {
    dispatch({
      type: CHANGING_PRODUCT_MAP_STATUS,
      id
    })

    return API.productMap
      .activeProductMap({ id, active, areaId })
      .then(response => {
        dispatch({
          type: CHANGE_PRODUCT_MAP_STATUS,
          id,
          active,
          areaId
        })
      })
      .catch(err => {
        dispatch({
          type: CHANGE_PRODUCT_MAP_STATUS_ERROR,
          id
        })
        return Promise.reject()
      })
  }
}

export const fetchSearch = (value, areaId, page, rowsPerPage, orderBy, order) => {
  return dispatch => {
    dispatch({
      type: FETCHING_PRODUCT_MAPS,
      value: true
    })

    return API.productMap
      .getSearchProductMap(value, areaId, page, rowsPerPage, orderBy, order)
      .then(response => {
        const { data = {} } = response
        const { items = {},
                last_update,
                total_records,
                can_change_status: canChangeStatus,
                can_update_amount: canUpdateAmount,
                pagination
              } = data

        dispatch({
          type: FETCH_PRODUCT_MAPS,
          canChangeStatus,
          canUpdateAmount,
          items,
          last_update,
          total_records,
          pagination
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_PRODUCT_MAPS_ERROR
        })
      })
  }
}

export const fetchRelationProductDownload = (value, areaId, can_change_area) => {
  return dispatch => {
    dispatch({
      type: FETCHING_PRODUCT_MAPS_DOWNLOAD
    })

    return API.productMap
      .getDownloadProductMap(value, areaId, can_change_area)
      .then(response => {
        const date = new Date()
          .toLocaleString()
          .replace(/\//g, '-')
          .replace(/:/g, '-')

        const filename = 'Mapa de produtos em ' + date + '.xlsx'

        const blob = new Blob([response.data], {
          type: 'application/xlsx',
          charset: 'UTF-8'
        })

        const createLink = () => {
          const link = document.createElement('a')

          if (link.download !== undefined) {
            const url = window.URL.createObjectURL(blob)

            link.setAttribute('href', url)
            link.setAttribute('download', filename)

            link.style = 'visibility: hidden'

            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }

        dispatch({
          type: FETCH_PRODUCT_MAPS_DOWNLOAD
        })

        return (navigator.msSaveBlob && navigator.msSaveBlob(blob, filename)) || createLink()
      })
      .catch(err => {
        dispatch({
          type: FETCH_PRODUCT_MAPS_DOWNLOAD_ERROR
        })
      })
  }
}

export const changeStatusDownloadError = () => {
  return dispatch => {
    dispatch({
      type: CHANGE_PRODUCT_MAPS_STATUS_DOWNLOAD_ERROR
    })
  }
}

export const fetchProductAmount = (id, areaId) => {
  return dispatch => {
    dispatch({
      type: FETCHING_PRODUCT_MAP,
      value: true
    })

    return API.productMap
      .getProductAmount(id, areaId)
      .then(response => {
        const data = response.data

        dispatch({
          type: FETCH_PRODUCT_MAP,
          productMap: data
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_PRODUCT_MAP_ERROR
        })
      })
  }
}

export const changeProductAmount = ({ id, areaId, amount, measureId }) => {
  return dispatch => {
    dispatch({
      type: CHANGING_PRODUCT_MAP_AMOUNT,
      id
    })

    return API.productMap
      .changeProductAmount({ id, areaId, amount, measureId })
      .then(response => {
        dispatch({
          type: CHANGE_PRODUCT_MAP_AMOUNT,
          ...response.data,
        })
      })
      .catch(err => {
        console.log({err})
        dispatch({
          type: CHANGE_PRODUCT_MAP_AMOUNT_ERROR,
          id
        })
        return Promise.reject()
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/productMap.js